/**
 * Session ID Management
 *
 * Extracted from use-event-logger to break circular dependency with auth.
 * The auth module needs to rotate session IDs on login/logout,
 * and event logger needs session IDs for logging.
 */

// Session ID stored globally so it persists across hook instances
let globalSessionId = crypto.randomUUID();

/**
 * Rotate to a new session ID (called on login/logout)
 */
export function rotateSessionId(): string {
  globalSessionId = crypto.randomUUID();
  return globalSessionId;
}

/**
 * Get the current session ID
 */
export function getSessionId(): string {
  return globalSessionId;
}
